import { render } from "./awards.html?vue&type=template&id=b9f4b062&ts=true"
import script from "./awards.vue?vue&type=script&lang=ts"
export * from "./awards.vue?vue&type=script&lang=ts"

import "./awards.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\mt7rk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__